import { render, staticRenderFns } from "./IconDebit.vue?vue&type=template&id=385fbfd5&"
import script from "./IconDebit.vue?vue&type=script&lang=js&"
export * from "./IconDebit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports